import { AngularFirestoreDocument, DocumentReference, QuerySnapshot } from "@angular/fire/firestore"
import { isObject } from "lodash"

export function updateUndefinedValues<T>(obj: T, deleteUndefinedValues = false): T {
  const object = { ...obj }
  Object.keys(obj).forEach(key => {
    if (object[key] === undefined) {
      if (deleteUndefinedValues) {
        delete object[key]
      } else {
        object[key] = object[key] || null
      }
    } else if (isObject(object[key]) && !Array.isArray(object[key]) && typeof object[key] !== "function") {
      object[key] = updateUndefinedValues(object[key])
    }
  })
  return object
}

export function getData<T>(collectionSnapshot: QuerySnapshot<any>): T[] {
  return collectionSnapshot.empty
    ? []
    : collectionSnapshot.docs.map<T>(bugSnapshot => {
      if (!bugSnapshot.exists) {
        return null
      }

      const bug = bugSnapshot.data() as any
      bug._id = bugSnapshot.id
      return bug
    })
}

export async function getDataItemFromQuery<T>(docRef: DocumentReference): Promise<T> {
  const doc = await docRef.get()
  return {
    _id: doc.id,
    ...doc.data(),
  } as any
}

export async function getDataItem<T>(docSnapshot: AngularFirestoreDocument<any>, useId = true): Promise<T> {
  const doc = await docSnapshot.ref.get()
  if (!doc.exists) {
    return null
  }

  const item = doc.data()
  if (useId) {
    item._id = doc.id
  }
  return item as T
}
